Config = {
	isMobile: ->
		true is $('.item-burger-mobile').is(':visible')

	isTouchDevice: ->
		true is ("ontouchstart" of window or window.DocumentTouch and document instanceof DocumentTouch)
}